import { render, staticRenderFns } from "./CostAllocationTags.vue?vue&type=template&id=7c66530d&scoped=true"
import script from "./CostAllocationTags.vue?vue&type=script&lang=js"
export * from "./CostAllocationTags.vue?vue&type=script&lang=js"
import style0 from "./CostAllocationTags.vue?vue&type=style&index=0&id=7c66530d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c66530d",
  null
  
)

export default component.exports